import { init, CoreParams, ClientParams } from './init';
import { markPerformance } from './performance/index';
import { ErrorReporter } from './errorReporter.type';

export const initCore = (params: CoreParams, errorReporter: ErrorReporter) => {
  window.mmClientApi = window.mmClientApi || [];
  window.mmClientApi.push('getPageData', (pageDataObject: ClientParams) => {
    markPerformance('core-start');
    init({
      ...params,
      platform: pageDataObject.platform,
      trafficSource: pageDataObject.trafficSource,
      trafficSourceAndId: pageDataObject.trafficSourceAndId,
      trafficId: pageDataObject.trafficId,
      mmUserIdentifier: pageDataObject.mmUserIdentifier,
    }, errorReporter);
  });
};

export * from './ads/ads.types';
export * from './init';
